import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Sessao } from '../model/sessao/sessao.model';
import { SessaoFiltro } from '../model/sessao/sessao-filtro.model';
import { PageModel } from '../model/page-mode.model';
import {SessaoBuscaContato} from '../model/sessao/sessao-busca-contato.model';
import {LogTransferenciaModel} from '../model/sessao/log-transferencia.model';
import {FilaEsperaFiltro} from '../model/FilaEsperaFiltro';
import {FilaEsperaResposta} from '../model/sessao/fila-espera-resposta.model';


@Injectable({
  providedIn: 'root'
})
export class SessaoService {
  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/sessao`;

  buscarSessoesComFiltro(filtro: SessaoFiltro, page: number, limit: number): Observable<PageModel> {
    // valores padrao ate implementar paginator
    return this.http.post<PageModel>(this.urlBase + `/buscar-com-filtro`, filtro, {
      headers: { 'no-loading': 'true' },
      params: {
        page: page,
        limit: limit
      }
    });
  }

  buscarSessaoAtualContato(contatoId: number): Observable<SessaoBuscaContato | null> {
    return this.http.get<SessaoBuscaContato | null>(`${this.urlBase}/contato/${contatoId}/atual`, { headers: { 'no-loading': 'true' } });
  }

  buscarHistoricoContato(contatoId: number, page: number, size = 10): Observable<PageModel> {
    return this.http.get<PageModel>(`${this.urlBase}/contato/${contatoId}/historico`, {
      params: new HttpParams().set('page', page).set('size', size),
      headers: { 'no-loading': 'true' }
    });
  }

  alterarSessao(sessao: Sessao): Observable<boolean> {
    return this.http.put<boolean>(`${this.urlBase}`, sessao);
  }

  inativarSessao(idSessao: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.urlBase}/inativar`, idSessao);
  }

  reiniciarSessao(idSessao: number): Observable<boolean> {
    return this.http.patch<boolean>(`${this.urlBase}/reiniciar`, idSessao);
  }

  buscarSessoesDoContato(contatoId: number): Observable<SessaoBuscaContato[]> {
    return this.http.get<SessaoBuscaContato[]>(`${this.urlBase}/buscar/contato/${contatoId}`);
  }

  buscarInformativoSessoesContatosPorCanal(canalId: number, operadorId: number, pagina: number, tamanhoPagina: number, filtro?: FilaEsperaFiltro): Observable<FilaEsperaResposta> {
    let params = new HttpParams()
      .set('pagina', pagina)
      .set('tamanhoPagina', tamanhoPagina);
    if (filtro?.atendimento?.id != null && filtro.atendimento.id !== -1) {
      params = params.set('atendimento', filtro.atendimento.id === 2 ? 0 : filtro.atendimento.id);
    }
    if (filtro?.sessao?.id != null && filtro.sessao.id !== -1) {
      params = params.set('sessao', filtro.sessao.id === 2 ? 0 : filtro.sessao.id);
    }
    return this.http.get<FilaEsperaResposta>(
      `${this.urlBase}/buscar-informativo-sessao-contato/canal/${canalId}/operador/${operadorId}`,
      { params }
    );
  }

  buscarLogTransferencia(idSessao: number): Observable<LogTransferenciaModel[]> {
    return this.http.get<LogTransferenciaModel[]>(`${this.urlBase}/logs-transferencia/sessao/${idSessao}`);
  }

}
